module.exports = __webpack_public_path__ + "static/media/walk-in-video-visit-white.2d0200e7.svg";